import Button from "@mui/material/Button";
import { styled } from "@mui/material";
import { createElement, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPagination } from "../../store/actions";
import iconEdit from "../../assets/svg/icon-edit-bottom-table.svg";
import iconDelete from "../../assets/svg/icon-delete-bottom-table.svg";
import ArrowLeft from "../../assets/svg/arrow-left-pagination.svg";
import ArrowRight from "../../assets/svg/arrow-right-pagination.svg";
import { copyToClipboard, formatPrice } from "../../helpers";
import { apiSetAlert } from "../../api/appApi";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import TableIndex from "./TableIndex";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useTheme } from "@mui/styles";
import { TabCell, TableTabsContainer, TableTabsWrapper, Thumb } from "./TableComponent";
import { setConfirm } from "../../store/actions/appAction";
import { apiSortAccountingCodes } from "../../api/accountingApi";

const PageAmountItem = styled("div")({
  backgroundColor: "white",
  position: "absolute",
  width: "100px",
  textAlign: "right",
  paddingRight: "10px",
});

const FixedIcon = styled("div")({
  width: "64px",
  backgroundColor: "white",
  height: "52px",
  position: "absolute",
  left: "0px",
  zIndex: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "2px 6px 6px #ebebeb",
  borderTop: "1px solid #e6e6e6",
});

const CustomizeIcon = styled(FixedIcon)({
  backgroundColor: "#F2F5FC",
  borderTop: "unset",
});

const isSelectable = (actions) => {
  if (!actions) {
    return false;
  } else if (actions["delete"] || actions["openDrawer"]) {
    return true;
  }
  return false;
};
export const PageHeader = (props) => {
  return props.activeTab ? (
    <div className="header-right">
      <div className="product">{props.activeTab.pageTitle}</div>
      <div className="show-product">{props.activeTab.pageDescription}</div>
    </div>
  ) : null;
};

export const HeaderActions = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = useSelector((state) => state.businessReducer.business?.token);
  const sortAccountingCodes = () => {
    const model = props.actions.sort?.model;
    dispatch(
      setConfirm("شماره گذاری مجدد", () => dispatch(apiSortAccountingCodes(token, model, props.fetchItems)))
    );
  };

  if (Object.keys(props.actions).length > 0) {
    return (
      // <div className={"header-left"}>
      <div className="d-flex">
        {/*{Object.keys(props.actions).includes("excel") ? (*/}
        {/*  <ExcelButton selectedItems={props.selectedItems} type={props.activeTab.key} excel={props.actions.excel} />*/}
        {/*) : null}*/}
        {/*{Object.keys(props.actions).includes("sort") ? <SortButton onClick={sortAccountingCodes} /> : null}*/}
        {Object.keys(props.actions).includes("add") ? (
          <AddButton action={props.actions.add} activeTab={props.activeTab} />
        ) : null}
        {Object.keys(props.actions).includes("back") ? (
          <div
            onClick={() => navigate(-1)}
            style={{
              color: "#A5A5A6",
              textDecoration: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              flexDirection: "row-reverse",
              gap: 12,
            }}
            className="left-title-product"
          >
            بازگشت &nbsp;
            <ArrowBackIcon />
          </div>
        ) : null}
      </div>
    );
  }
  return null;
};

// const ExcelButton = (props) => {
//     const dispatch = useDispatch();
//     const token = useSelector((state) => state.businessReducer.business?.token);
//
//     const [excelButtonActive, setExcelButtonActive] = useState(false);
//
//     function toggle() {
//         setExcelButtonActive(!excelButtonActive);
//     }
//
//     return (
//         <>
//             <div className={"active-header-left"}>
//                 <button onClick={() => toggle()}>
//                     <img className="exxcel" src={excelIcon} alt="excelIcon"/>
//                     <img className="active-exxcel" src={excelIconActive} alt="excelIconActive"/>
//                     اکسل
//                     {excelButtonActive ? (
//                         <div className="box-excel">
//                             <div
//                                 className="item-box"
//                                 onClick={() => {
//                                     dispatch(props.excel.export(token, props.type, props.selectedItems));
//                                 }}
//                             >
//                                 <img src={iconExitExcel} alt="iconExitExcel"/>
//                                 دریافت اطلاعات
//                             </div>
//                             {props.excel.import && (
//                                 <div
//                                     onClick={() =>
//                                         dispatch(
//                                             appSetModal(
//                                                 {
//                                                     component: "import-excel",
//                                                     maxWidth: "900px",
//                                                 },
//                                                 true
//                                             )
//                                         )
//                                     }
//                                     className="item-box"
//                                 >
//                                     <img src={iconLoginExcel} alt="iconLoginExcel"/>
//                                     ورود اطلاعات
//                                 </div>
//                             )}
//                         </div>
//                     ) : (
//                         <></>
//                     )}
//                 </button>
//             </div>
//         </>
//     );
// };

const AddButton = (props) => {
  const navigate = useNavigate();

  const navigateToRoute = (e) => {
    navigate(props.action.url, {
      state: {
        type: props.activeTab.key,
      },
    });
    e.preventDefault();
  };

  const theme = useTheme();

  return (
    <Button
      disableElevation
      disableRipple
      sx={{
        width: "100px",
        height: "40px",
        fontSize: 12,
        // fontWeight: 'bold',
        display: "flex",
        justifyContent: "center",
        padding: "6px 8px",
        borderRadius: "4px",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "white",
        },
      }}
      color="primary"
      variant="contained"
      startIcon={<img style={{ width: 14, marginLeft: 8 }} src={props.action.icon} alt="plusIcon" />}
      href={props.action.url}
      onClick={(e) => navigateToRoute(e)}
    >
      {props.action.title}
    </Button>
  );
};

// const SortButton = (props) => {
//     const [buttonActive, setButtonActive] = useState(false);
//
//     function toggle() {
//         setButtonActive(!buttonActive);
//     }
//
//     return (
//         <>
//             <div className={"active-header-left"}>
//                 <button style={{width: "auto", borderColor: "#aeaeae"}} onClick={() => toggle()}>
//                     <img src={MoreIcon}/>
//                     {buttonActive ? (
//                         <div className="box-excel">
//                             <div className="item-box" onClick={props.onClick}>
//                                 شماره گذاری مجدد اسناد
//                             </div>
//                         </div>
//                     ) : (
//                         <></>
//                     )}
//                 </button>
//             </div>
//         </>
//     );
// };

const getRightPosition = (items, container, activeIndex) => {
  try {
    const itemRight = items.current[activeIndex]?.getBoundingClientRect().right;
    const containerRight = container.current?.getBoundingClientRect().right;

    return parseInt((containerRight ?? 0) - (itemRight ?? 0));
  } catch {
    return 0;
  }
};

const getWidth = (items, container, activeIndex) => {
  try {
    const itemWidth = items.current[activeIndex]?.getBoundingClientRect().width;
    return parseInt((itemWidth ?? 64) - 32);
  } catch {
    return 0;
  }
};

export const TableTabs = (props) => {
  const itemsRef = useRef([]);
  const containerRef = useRef(createElement("div"));
  return (
    <TableTabsWrapper>
      <TableTabsContainer disableRipple ref={containerRef}>
        {props.tabs.length > 1 &&
          props.tabs
            .map((tab, key) => {
              return (
                <TabCell
                  key={key}
                  ref={(el) => (itemsRef.current[key] = el)}
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  fullWidth
                  active={props.activeTab && props.activeTab.key === tab.key}
                  onClick={() => {
                    props.setActiveTab(tab);
                  }}
                >
                  {tab.title}
                </TabCell>
              );
            })}
        <Thumb
          right={getRightPosition(itemsRef, containerRef, props.activeTabKey)}
          width={getWidth(itemsRef, containerRef, props.activeTabKey)}
        />
      </TableTabsContainer>
    </TableTabsWrapper>
  );
};

// export const TableTitles = (props) => {
//     const {actions, activeTab} = props;
//     const [anchorEl, setAnchorEl] = useState(null);
//
//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget);
//     };
//
//     const handleClose = () => {
//         setAnchorEl(null);
//     };
//
//     return (
//         <Container maxWidth="xl" style={{padding: "0px"}}>
//             <div className="header-tables">
//                 <CustomizeIcon>
//                     <IconButton onClick={handleClick}>
//                         {/*<DnsIcon color="text.disabled"/>*/}
//                         <CustomizeColumnIcon/>
//                     </IconButton>
//                     <EditColumns
//                         key={activeTab?.key}
//                         tabKey={activeTab?.key}
//                         titles={props.allTitles}
//                         selectedTitles={props.titles}
//                         handleClose={handleClose}
//                         anchorEl={anchorEl}
//                     />
//                 </CustomizeIcon>
//                 <div className="title-table">
//                     {isSelectable(actions) && <div className="item-data-body" style={{cursor: "default"}}/>}
//                     {isSelectable(actions) && (
//                         <div className="checkbox">
//                             <label className="container">
//                                 <input
//                                     type="checkbox"
//                                     checked={props.tableItemsLength > 0 && props.tableItemsLength === props.selectedItemsLength}
//                                     onClick={() => props.selectAllItems()}
//                                 />
//                                 <span
//                                     className={
//                                         props.tableItemsLength > props.selectedItemsLength && props.selectedItemsLength > 0
//                                             ? "checkmarks"
//                                             : "checkmark"
//                                     }
//                                 />
//                             </label>
//                         </div>
//                     )}
//                     <div className="hashtag-item">#</div>
//                     {props.titles.map((title, key) => {
//                         return (
//                             <div className="item-title" key={key} style={{width: `${title.size * 50}px`}}>
//                                 <div className="arrow-top-div">
//                                     <div className="">
//                                         <img
//                                             src={arrowTop}
//                                             alt="arrowTop"
//                                             style={{
//                                                 cursor: "pointer",
//                                                 opacity: props.sortQuery.key === title.key && props.sortQuery.dir === "ASC" ? 1 : 0.5,
//                                             }}
//                                             onClick={() => {
//                                                 props.setSortQuery({
//                                                     key: title.key,
//                                                     dir: "ASC",
//                                                 });
//                                                 props.searchItems({
//                                                     key: title.key,
//                                                     dir: "ASC",
//                                                 });
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="text-item">{title.name}</div>
//                             </div>
//                         );
//                     })}
//                     {/*{isSelectable(actions) && <div style={{width: `64px`}}/>}*/}
//                 </div>
//             </div>
//         </Container>
//     );
// };

// export const TableSearch = (props) => {
//     const {actions} = props;
//     const [activeInput, setActiveInput] = useState(null);
//
//     return (
//         <div className="search-table">
//             <FixedIcon/>
//             <div className="table-searchs item-data-table">
//                 {isSelectable(actions) && (
//                     <div className="icon-search">
//                         <img src={iconSearch} alt="iconSearch"/>
//                     </div>
//                 )}
//                 {props.activeTab && props.activeTab.key === "userReport" ? (
//                     <div className="id-items-table"/>
//                 ) : (
//                     <div style={{width: "85px"}}/>
//                 )}
//                 {props.titles.map((title, key) => {
//                     return (
//                         <div
//                             key={key}
//                             className="search-input"
//                             style={{width: `${title.size * 50}px`, opacity: `${title.disableSearch ? 0.5 : 1}`}}
//                             onClick={() => {
//                                 if (!title.disableSearch) {
//                                     setActiveInput(title.key);
//                                 }
//                             }}
//                         >
//                             <div className="box-inputs-searchh">
//                                 <img className="img-search-table" src={iconSearch} alt="iconSearch"/>
//                                 <input
//                                     className={activeInput === title.key ? "active-input-search-table" : "input-search-table"}
//                                     onKeyDown={(e) => {
//                                         if (e.key === "Enter") {
//                                             // if (e.target.value.length >= 0) {
//                                             props.setSearchQuery({
//                                                 mainColumn: title.mainColumn ? title.searchKey ?? title.key : null,
//                                                 searchText: title.mainColumn ? e.target.value : null,
//                                                 subColumn: title.mainColumn ? null : title.searchKey ?? title.key,
//                                                 altSearchText: title.mainColumn ? null : e.target.value,
//                                                 type: "1",
//                                             });
//                                             props.searchItems(undefined, {
//                                                 mainColumn: title.mainColumn ? title.searchKey ?? title.key : null,
//                                                 subColumn: title.mainColumn ? null : title.searchKey ?? title.key,
//                                                 searchText: e.target.value,
//                                                 type: "1",
//                                             });
//                                         }
//                                         // }
//                                     }}
//                                     type={"text"}
//                                 />
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

export const TableItems = (props) => {
  const { sumAmountInfo } = props
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let paginateStore = useSelector((state) => state.paginationReducer);
  const { page, limit } = paginateStore;
  // const loading = useSelector((state) => state.appReducer.loading);
  const loading = false;
  const secretView = useSelector((state) => state.appReducer.secretView);

  const copyText = (text) => {
    dispatch(apiSetAlert("کپی شد", "success"));
    copyToClipboard(text);
  };

  let selectedItems = props.selectedItems;

  const displayValue = (item, title, all) => {
    let value = title.price ? "0" : "-";
    if (secretView) {
      value = "********";
    } else if (title.getValue) {
      value = title.getValue(item, all);
    } else if (item[title.key]) {
      value = title.price ? formatPrice(item[title.key]) : item[title.key];
    }

    value = title.price ? formatPrice(value) : value;

    if (title.navigate) {
      return (
        <Link to={title.navigate + (title.navigateKey ? title.navigateKey(item) : item.id)}>{value}</Link>
      );
    }
    return value;
  };

  return (
    <TableIndex
      copyText={copyText}
      displayValue={displayValue}
      items={props.items}
      sumAmountInfo={sumAmountInfo}
      limit={limit}
      loading={loading}
      page={page}
      searchItems={props.searchItems}
      secretView={secretView}
      selectAllItems={props.selectAllItems}
      selectItem={props.selectItem}
      selectedItems={selectedItems}
      selectedItemsLength={props.selectedItemsLength}
      setSortQuery={props.setSortQuery}
      sortQuery={props.sortQuery}
      tableItemsLength={props.tableItemsLength}
      titles={props.titles}
      {...props}
    />
  );
};

export const FooterActions = (props) => {
  const navigate = useNavigate();

  const { activeTab, ActionSection, selectedItems, rows } = props;

  const FooterComponent = activeTab?.FooterComponent;

  const selectedItem = selectedItems ? selectedItems[0] : undefined;
  const getRow = (id) => {
    const found = rows.find(x => x.id === id)
    if (found) {
      return found
    }
  }
  return selectedItems.length > 0 ? (
    <div className="value-select-item">
      {(!FooterComponent && selectedItems.length > 1) && (
        <div className="item-value-right-select">
          <b>{selectedItems.length ?? 0}</b> ردیف انتخاب شده
        </div>
      )}
      {selectedItems.length > 0 && FooterComponent ?  <FooterComponent selectedItems={selectedItems} selectedItem={selectedItem} />:
      <div className="flex-row d-flex">
        {ActionSection && <ActionSection {...{ selectedItems }} />}
        {!activeTab?.notEditable && selectedItems.length === 1 ? (
          <button
            className="button-footer-table-edit"
            onClick={() => {
              const row = getRow(selectedItems[0])
              const factorTypes = ["buy", "buyReturn", "sale", "saleReturn", "waste", "income", "cost", "receive", "payment"];
              if (factorTypes.includes(row.type)) {
                navigate(`./${row.type}/${selectedItems[0]}`);

              } else {
                navigate(`./${selectedItems[0]}`);
              }
            }}
          >
            <img src={iconEdit} alt="iconEdit" />
            <div>ویرایش</div>
          </button>
        ) : null}
        <button className="me-3 button-footer-table-delete" onClick={() => props.deleteItems()}>
          <img src={iconDelete} alt="iconDelete" />
          <div>حذف</div>
        </button>
      </div>
      }
    </div>
  ) : null;
};

export const Pagination = (props) => {
  const dispatch = useDispatch();
  const { onlyPagination, onlySelect } = props;

  const [showLimitDropdown, setShowLimitDropdown] = useState(false);
  let paginateStore = useSelector((state) => state.paginationReducer);

  const defaultPagination = {
    currentPage: paginateStore.page ?? 1,
    limit: paginateStore.limit ?? 20,
    lastPage: 1,
    hasNextPage: false,
    hasPreviousPage: false,
    nextPage: 0,
    previousPage: 0,
  };

  const from = (defaultPagination.currentPage - 1) * defaultPagination.limit + 1;
  const to = (defaultPagination.currentPage - 1) * defaultPagination.limit + defaultPagination.limit;

  const limitRows = [
    { value: 5 },
    { value: 10 },
    { value: 15 },
    { value: 20 },
    { value: 30 },
    { value: 50 },
    { value: 100 },
  ];

  const [paginationData, setPaginationData] = useState(defaultPagination);

  useEffect(() => {
    setPaginationData(props.paginateData ?? defaultPagination);
    if (props.paginateData && paginateStore.page > props.paginateData.lastPage) {
      setPage(props.paginateData.lastPage, true);
    }
  }, [props.activeTab, props.paginateData]);

  useEffect(() => {
    setPage(1, true);
  }, [props.activeTab]);

  const setPage = (i, status) => {
    if (!status || i === paginateStore.page) return;
    dispatch(
      setPagination({
        page: i,
        limit: paginateStore.limit,
      })
    );
  };

  const setLimit = (i) => {
    if (i) {
      dispatch(
        setPagination({
          page: 1,
          limit: i,
        })
      );
    }
    setShowLimitDropdown(!showLimitDropdown);
  };

  const renderItems = () => {
    let items = [];

    const currentPage = paginateStore.page;
    let { lastPage } = paginationData;
    let firstPageNumber = currentPage - 3;
    if (firstPageNumber <= 0) firstPageNumber = 1;
    let lastPageNumber = currentPage + 3;
    if (lastPageNumber > lastPage) lastPageNumber = lastPage;
    for (let pageNumber = firstPageNumber; pageNumber <= lastPageNumber; pageNumber++) {
      if (pageNumber <= lastPage) {
        items.push(
          <div
            key={pageNumber}
            className={pageNumber === currentPage ? "round-effect active" : "round-effect"}
            onClick={() => setPage(pageNumber, true)}
          >
            {pageNumber}
          </div>
        );
      }
    }

    return items;
  };
  const onlyPaginationStyles = onlyPagination
    ? {
      marginBottom: 0,
      backgroundColor: "unset",
      display: "flex",
      justifyContent: "end",
    }
    : onlySelect
      ? {
        width: "270px",
        alignItems: "center",
        justifyContent: "left",
      }
      : {};
  return props.active ? (
    <div className="warp-pagination" style={onlyPaginationStyles}>
      {!onlySelect && (
        <div className="pagination">
          <div className="flex-container">
            <div className="paginate-ctn">
              <div
                className={paginationData.hasPreviousPage ? "round-effect" : "active-round-effect"}
                onClick={() => setPage(paginateStore.page - 1, paginationData.hasPreviousPage)}
              >
                <img src={ArrowRight} alt="ArrowRight" />
              </div>
              {renderItems()}
              <div
                className={!paginationData.hasNextPage ? "active-round-effect" : "round-effect"}
                onClick={() => setPage(paginateStore.page + 1, paginationData.hasNextPage)}
              >
                <img src={ArrowLeft} alt="ArrowLeft" />
              </div>
            </div>
          </div>
        </div>
      )}
      {!onlyPagination && (
        <div className="row-pagination">
          {/* <div className="text-row-pagination">نشان دادن</div> */}
          <div className="number-row">
            <div className="number-default-select" onClick={() => setLimit()}>
              <span style={{ color: "#7E8C9E" }}>ردیف</span>
              <span>{paginateStore.limit ?? 5}</span>
              <span>
                <KeyboardArrowDown fontSize="small" sx={{ color: "#7E8C9E" }} />
              </span>
            </div>
            <PageAmountItem>
              {showLimitDropdown ? (
                limitRows.map((item, index) => {
                  return (
                    <div key={index}>
                      <div
                        className={
                          item.value === paginationData.limit ? "active-item-number-row" : "item-number-row"
                        }
                        onClick={() => setLimit(item.value)}
                      >
                        {item.value}
                      </div>
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </PageAmountItem>
          </div>
          <div className="text-row-pagination">
            نمایش &nbsp;
            {`${from} - ${to}`}
          </div>
        </div>
      )}
    </div>
  ) : null;
};
